import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Button from "@/components/button.vue"
  import DeliverableEditor from "@/components/editors/deliverable.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Deliverable as DeliverableResolver} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import {ref} from "vue"
  import ContentModal from "@/components/modals/content.vue"
  import TrademarkSelector from "@/components/selectors/trademark.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'create_deliverable',
  setup(__props) {

  const deliverableResolver = new DeliverableResolver()
  const deliverable = ref<Deliverable>({
    type: "PRODUCT"
  })
  const selectingTrademark = ref<boolean>(null)

  async function save() {
    await deliverableResolver.create(deliverable.value)
    deliverableRedirect()
  }

  function deliverableRedirect() {
    router.push({
      name: "deliverables"
    })
  }

  function selectTrademark() {
    deliverable.value.trademarkID = deliverable.value.trademark.id
    selectingTrademark.value = false
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VerticalNavigator, null, {
    default: _withCtx(() => [
      _createVNode(Breadcrumb, {
        links: [{
        title: 'RutSolve',
        routeName: 'index'
      }, {
        title: 'Deliverables',
        routeName: 'deliverables'
      }],
        title: "Create"
      }),
      _cache[6] || (_cache[6] = _createElementVNode("h1", null, " Create Deliverable ", -1)),
      _createVNode(DeliverableEditor, {
        value: deliverable.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((deliverable).value = $event))
      }, null, 8, ["value"]),
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, " Trademark ", -1)),
      _createVNode(Button, {
        title: "Trademark",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectingTrademark.value = true))
      }),
      (selectingTrademark.value)
        ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(TrademarkSelector, {
                value: deliverable.value.trademark,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((deliverable.value.trademark) = $event)),
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (selectTrademark()))
              }, null, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createVNode(Button, {
        title: "Cancel",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (deliverableRedirect()))
      }),
      _createVNode(Button, {
        title: "Save",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (save()))
      })
    ]),
    _: 1
  }))
}
}

})